import { hasNoElements } from "Utils/Array";
import { generateUniqueId } from "Utils/UniqueId";
import { IOmikronResult } from "Model/Omikron/IOmikronResult";
import { IAddressValidationResult } from "../Model/Omikron/IAddressValidationResult";
import { IDuplicateCheckResult } from "../Model/Omikron/IDuplicateCheckResult";
import { asType, get } from "./Request";

export async function duplicateCheck(token: string, idList: string[]): Promise<IDuplicateCheckResult[][]> {
  return addOmikronMetadata(
    await asType<IDuplicateCheckResult[][]>(await get(`duplicatecheck/${idList.join(`,`)}`, token))
  );
}

export async function addressValidation(token: string, idList: string[]): Promise<IAddressValidationResult[][]> {
  return addOmikronMetadata(
    await asType<IAddressValidationResult[][]>(await get(`addressvalidation/${idList.join(`,`)}`, token))
  );
}

function addOmikronMetadata<T extends IOmikronResult>(resultsList: T[][]): T[][] {
  if (hasNoElements(resultsList)) {
    return [];
  }

  return resultsList.map((resultList) => resultList.map((entry, index) => ({
    ...entry,
    "@resultId": generateUniqueId(),
    "@isOrigin": false,
    "@resultBadge": `${index + 1}`
  })));
}
